import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  public generateUrl(fragment: string): string {
    const origin = this.document.location.origin;
    if (origin === 'http://localhost:4200') {
      return `https://localhost:44325/api/${fragment}`;
    }
    if (origin === 'https://dev.fintech.initgroup.no') {
      return `https://init-datawarehouse-api-dev.purpleglacier-c83c8d63.northeurope.azurecontainerapps.io/api/${fragment}`;
    }
    if (origin === 'https://fintech.initgroup.no') {
      return `https://init-datawarehouse-api-prod.victoriousgrass-b581ed64.westeurope.azurecontainerapps.io/api/${fragment}`;
    }
    // Handle other environments if necessary
    return `${origin}/api/${fragment}`;
  }

  public getCurrentRoute(): string {
    const indexOfRoute = this.document.URL.indexOf('/#/') + 2;
    if (indexOfRoute == 1) {
      return '';
    }
    return this.document.URL.substring(indexOfRoute);
  }
}
